module.exports = __webpack_public_path__ + "assets/troika14a045.otf";